export const buildBookingContactsFilterGroups = (venueOwnerships = [], filterOptions = {}) => [
  {
    id: 'venue',
    label: 'Venue',
    filters: [
      {
        id: 'venue_ownership_id',
        label: 'Venue',
        type: 'checkbox',
        options: venueOwnerships.map(vo => ({
          value: String(vo.id),
          label: vo.name,
        })),
      },
    ],
  },
  {
    id: 'contact_details',
    label: 'Contact Details',
    filters: [
      {
        id: 'contact_type',
        label: 'Contact Type',
        type: 'checkbox',
        options: (filterOptions.contactTypeOptions || []).map(o => ({
          value: o.value,
          label: o.label,
        })),
      },
      {
        id: 'company_name',
        label: 'Company',
        type: 'search',
        options: (filterOptions.companyOptions || []).map(o => ({
          value: o.value,
          label: o.label,
        })),
      },
      {
        id: 'auto_added',
        label: 'Auto-Added',
        type: 'checkbox',
        options: [
          { value: 'yes', label: 'Yes' },
          { value: 'no', label: 'No' },
        ],
      },
    ],
  },
];
